module.exports = __webpack_public_path__ + "img/as4.8ca294c1.png";